import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosWithTokenRefresh,
    handleError,
    logError
} from 'tradera-utils/api';

export const getStartPageConfig = languageCodeIso2 => {
    return axiosWithTokenRefresh()
        .get(`${ENDPOINTS.CMS_API}/api/pages/start?locale=${languageCodeIso2}`)
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data);
};

export const getTrendingBrands = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.CMS_API + '/api/trending/brands')
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || [])
        .then(items =>
            items
                .map(({ name, index, slug, logoImageUrl }) => ({
                    name,
                    index,
                    url: `/brand/${slug}`,
                    logoImageUrl
                }))
                .sort(sortByIndex)
        );
};

const sortByIndex = (a, b) => a.index - b.index;

export const getTrendingSearches = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.CMS_API + '/api/trending/searches')
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || [])
        .then(items =>
            items
                .map(({ index, categoryId, query }) => ({
                    name: query,
                    index,
                    url: `/search?q=${query}${
                        categoryId ? `&categoryId=${categoryId}` : ''
                    }&sortBy=MostBids`
                }))
                .sort(sortByIndex)
        );
};

export const getWishListItems = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.WISHLIST + '?filter=active&itemsPerPage=8')
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data.items || []);
};

export const getFavouriteSellers = () => {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.FAVOURITE_SELLERS)
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || {});
};
